import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from '@tanstack/react-router';

import { useInterval } from '@/App.hooks';
import { Fonts } from '@/services/fonts/Fonts';

import './App.css';
import styles from './App.module.css';

import { tryRefreshToken, useRefreshOnBuild } from './auth/Auth.hooks';
import { router } from './App.router';

function App() {
	const INTERVAL_TIME = 60 * 1000;
	useRefreshOnBuild();
	useInterval(() => {
		tryRefreshToken('/', { minutes: 1 });
	}, INTERVAL_TIME);

	const classNames = ['App', styles['app']];
	return (
		<HelmetProvider>
			<Fonts>
				<div className={classNames.join(' ')}>
					<RouterProvider router={router} />
				</div>
			</Fonts>
		</HelmetProvider>
	);
}

export default App;
